import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { getActions } from './actions.js';
import { getInitialState } from './helpers.js';
import { reducer } from './reducer.js';

const DEFAULT_SOLUTION_MAX_QUANTITY = 5;
const SolutionsEcommContext = /*#__PURE__*/ React.createContext({});
const useSolutionsEcommContext = ()=>React.useContext(SolutionsEcommContext)
;
const SolutionsEcommProvider = ({ children , maxOrderableQuantity  })=>{
    const { activeVariant  } = useProductData();
    const initialState = React.useMemo(()=>getInitialState()
    , [
        activeVariant
    ]);
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const actions = React.useMemo(()=>getActions(dispatch)
    , []);
    const value = React.useMemo(()=>({
            actions,
            state,
            maxOrderableQuantity: maxOrderableQuantity !== null && maxOrderableQuantity !== void 0 ? maxOrderableQuantity : DEFAULT_SOLUTION_MAX_QUANTITY
        })
    , [
        actions,
        state
    ]);
    return /*#__PURE__*/ React.createElement(SolutionsEcommContext.Provider, {
        value: value
    }, children);
};

export { SolutionsEcommContext, SolutionsEcommProvider, useSolutionsEcommContext };
//# sourceMappingURL=SolutionsEcommContext.js.map
